import EdelvivesAIChatbot from './EdelvivesAIChatbot';

export default EdelvivesAIChatbot;